import { Dropdown } from "primereact/dropdown"
import commonStyles from "../../../common.module.css"
import { useMachines } from "../../../../api/queries/useMachines"
import { useMemo, useRef, useState } from "react"
import { usePreventionsUnique } from "../../../../api/queries/usePreventionsUnique"
import { MultiSelect } from "primereact/multiselect"
import { useUsers } from "../../../../api/queries/useUsers"
import { InputNumber } from "primereact/inputnumber"
import { Button } from "primereact/button"
import { useHistory } from "react-router-dom"
import api from "../../../../api"
import { Toast } from "primereact/toast"

export default function TaskPreventionRemindForm() {
  const history = useHistory()
  const toastRef = useRef()

  const [machine, setMachine] = useState("")
  const onMachineChange = (e) => setMachine(e.value)

  const [selectedPreventions, setSelectedPreventions] = useState([])
  const onSelectedPreventionsChange = (e) => setSelectedPreventions(e.value)

  const [selectedUsers, setSelectedUsers] = useState([])
  const onSelectedUsersChange = (e) => setSelectedUsers(e.value)

  const [days, setDays] = useState(1)
  const onDaysChange = (e) => setDays(e.value)

  const [disabled, setDisabled] = useState(false)

  const { data: machines = [] } = useMachines()
  const { data: preventionsUnique = [] } = usePreventionsUnique(machine)
  const { data: users = [] } = useUsers()

  const usersWithEmail = useMemo(() => users.filter((user) => !!user.email), [users])

  const onBack = () => history.push("/tasks/preventions")

  const onSubmit = async (e) => {
    e.preventDefault()
    setDisabled(true)

    const payload = selectedPreventions.map((prevention) => ({
      task_uuid: prevention,
      days,
      users: selectedUsers
    }))

    try {
      await api.post("/task-notification", payload)
      toastRef.current.show({ severity: 'success', summary: 'Připomenutí vytvořeno.' });
      reset()
    } catch {
      reset()
    }
  }

  const reset = () => {
    setDisabled(false)
    setMachine("")
    setSelectedPreventions([])
    setSelectedUsers([])
    setDays(1)
  }

  return (
    <div className="col-12 md:col-6">
      <Toast ref={toastRef} />

      <form onSubmit={onSubmit}>
        <div className="p-fluid">
          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Stroj:</label>
            <Dropdown value={machine} options={machines} optionValue={"uuid"}
              optionLabel={"name"} emptyMessage={"Žádné záznamy"}
              filter={true} filterBy="name" onChange={onMachineChange} />
          </div>

          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Údržba:</label>
            <MultiSelect value={selectedPreventions} options={preventionsUnique} optionValue={"task_uuid"}
              optionLabel={"name"} emptyMessage={"Žádné záznamy"}
              onChange={onSelectedPreventionsChange} disabled={!machine}
              filter={true} filterBy="name" />
          </div>

          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Uživatelé:</label>
            <MultiSelect value={selectedUsers} options={usersWithEmail} optionValue={"uuid"}
              optionLabel={"name"} emptyMessage={"Žádné záznamy"}
              onChange={onSelectedUsersChange} disabled={selectedPreventions.length === 0}
              filter={true} filterBy="name" />
          </div>

          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Upozornit dní předem:</label>
            <InputNumber value={days} min={1} step={1}
              onChange={onDaysChange} />
          </div>
        </div>

        <div className={"flex"}>
          <Button type={"button"} label={"Zpět"} className={"p-button-warning m-1"}
            onClick={onBack} />

          <div className={"ml-auto"}>
            <Button type={"submit"} label={"Uložit"} className={"m-1"} disabled={disabled} />
          </div>
        </div>
      </form>
    </div>
  )
}
